<template>
    <div>
        <div class="breadcrumbs" id="breadcrumbs">
            <router-link class="breadcrumb-link" to="/orders/">BookBlock Orders & Jobs</router-link>
            <router-link class="breadcrumb-link" :to="'/orders/' + item.id">{{ item.name }}</router-link>
        </div>
        <h3>{{ item.name }} <span>{{itemType }} detail</span></h3>

        
        <div id="job-overview">
            <div id="job-overview-left">
                <div class="note" style="width: 100%; margin-bottom: 10px">
                    <b>This Bookblock enquiry has been received by our team and is under review.</b> 
                    Your customer agent will get in touch when it is processed with a customer pack & quote for you to review, or to ask for additional details if needed. 
                </div>
                
                <table v-if="itemType === 'enquiry'" id="enquiry-info"  class="worksends-table" >
                    <tbody>
                    <tr>
                        <td>
                            <label>Enquiry ID</label>
                            <div class="value"><span>#</span><b>{{ item.id }}</b></div>
                        </td>
                        <td>
                            <label>Quantity</label>
                            <div class="value"><b>{{ item.quantity }}</b> <span>units</span></div>
                        </td>
                        <td class="field-status">
                            <label>Enquiry Status</label>
                            <div :class="'status status-'+item.status">{{ enquiryStatusName(item.status) }}</div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3">
                            <label>Enquiry Details</label>
                            <div class="enquiry-details">{{ item.enquiry_details?.message }}</div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <table v-else id="job-info"  class="worksends-table">
                    <tbody>
                    <tr>
                        <td>
                            <label>Job ID</label>
                            <div class="value"><span>#</span><b>{{ item.id }}</b></div>
                        </td>
                        <td>
                            <label>Order Name</label>
                            <div class="value">{{ item.order_name }} <span>#{{ item.order_id }}</span></div>
                        </td>
                        <td class="field-status">
                            <label>Job Status</label>
                            <div :class="'status status-'+item.status">{{ statusName(item.status) }}</div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label>Quantity</label>
                            <div class="value"><b>{{ item.quantity }}</b> <span>units</span></div>
                        </td>
                        <td>
                            <label>Completion Date</label>
                            <div class="value">
                                {{ (item.finished_at ?? item.planned_finish ?? item.deadline) | moment("DD/MM/YY") }}
                                <span v-if="!item.finished_at" class="estimate">(est.)</span>
                            </div>
                        </td>
                        <td class="field-status">
                            <label>Production Progress</label>
                            <div class="production-progress"  v-if="item.production_steps?.total">
                                <doughnut-chart :width="32" :height="32" :options="chartOptions" :chart-data="donughtChartData(item.production_steps)"></doughnut-chart>
                                <b>{{ Math.round((item.production_steps.finished / item.production_steps.total) * 100) }}%</b>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="tool-actions">
                    <div class="tool-actions-left">
                        <div v-if="itemType === 'job'" class="ws-button ws-button-main" @click="modals.omsEnquiryModal = true">Reorder This Item</div>
                    </div>
                </div>
            </div>
            
            <div id="job-overview-right">
                <table id="job-quote"  class="worksends-table">
                    <tbody>
                    <tr>
                        <td>
                            <h5>Order Quote</h5>
                        </td>
                        <td>
                            
                        </td>
                    </tr>
                    <tr v-if="!lastCustomerPackQuote">
                        <td colspan="2">There is no quote for this {{ itemType }} yet. Our team is working on providing you with the quote. Your customer agent will get in touch when it is ready.</td>
                    </tr>
                    <tr v-if="lastCustomerPackQuote?.ppu">
                        <td>Price Per Unit</td>
                        <td>{{ currencySymbol }}<b>{{ lastCustomerPackQuote.ppu }}</b></td>
                    </tr>
                    <tr v-if="lastCustomerPackQuote?.quantity">
                        <td>Quantity</td>
                        <td><b>{{ lastCustomerPackQuote.quantity }}</b> units</td>
                    </tr>
                    <tr v-if="lastCustomerPackQuote?.subtotal">
                        <td>Order Subtotal</td>
                        <td>{{ currencySymbol }}<b>{{ lastCustomerPackQuote.subtotal }}</b></td>
                    </tr>
                    <tr v-if="lastCustomerPackQuote?.shipping">
                        <td>Order Shipping</td>
                        <td>{{ currencySymbol }}<b>{{ lastCustomerPackQuote.shipping }}</b></td>
                    </tr>
                    <tr v-if="lastCustomerPackQuote?.extra">
                        <td>Extra Charges</td>
                        <td>{{ currencySymbol }}<b>{{ lastCustomerPackQuote.extra }}</b></td>
                    </tr>
                    <tr v-if="lastCustomerPackQuote?.total">
                        <td><b>Order Total Price</b></td>
                        <td>{{ currencySymbol }}<b>{{ lastCustomerPackQuote.total }}</b></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        

        <h4><b>Customer Packs</b></h4>
        <table v-if="item.customer_packs?.length"  id="oms-job-customer-packs"  class="worksends-table">
            <thead>
            <tr>
                <th>Customer Pack Version</th>
                <th>Date Created</th>
                <th>Status</th>
                <th>Replied By</th>
                <th>Reply / Request</th>
                <th style="width: 150px">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="pack in item.customer_packs" v-bind:key="pack.id">
                <td class="field-version">
                    <a target="_blank" :href="'/docs/pack/' + pack.key">
                        <div class="oms-file-icon"><div class="text">CP</div></div>
                        <div>Version # {{ pack.version }}</div>
                    </a>
                </td>
                <td>
                    {{ pack.created_at | moment("DD/MM/YY h:mma") }}
                </td>
                <td>
                    <div :class="'customer-pack-status status-'+pack.status">{{ pack.status }}</div>
                </td>
                <td>
                    {{ pack.replied_by }}
                </td>
                <td style="max-width: 500px;">
                    {{ pack.reply }} {{ pack.reply }} {{ pack.reply }} {{ pack.reply }} {{ pack.reply }} {{ pack.reply }}
                </td>
                <td>
                    <a target="_blank" :href="'/docs/pack/' + pack.key" class="ws-button ws-button-secondary small">View Document</a>
                </td>
            </tr>
            </tbody>
        </table>
        <div v-else class="small-note">
            There are no customer packs on this {{ itemType }}.
        </div>

        <h4><b>Attachments</b></h4>
        <table v-if="item.attachments?.length"  id="oms-job-attachments"  class="worksends-table">
            <thead>
            <tr>
                <th>Attached File</th>
                <th>Date Added</th>
                <th style="width: 160px">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="file in item.attachments" v-bind:key="file.id">
                <td class="field-file-name">
                    <a target="_blank" :href="downloadLink(file.public_key)">
                        <div class="oms-file-icon"><div class="text">{{ file.file_info.extension }}</div></div>
                        <div>{{ file.name }}</div>
                    </a>
                </td>
                <td>
                    {{ file.created_at | moment("DD/MM/YY h:mma") }}
                </td>
                <td>
                    <a target="_blank" :href="downloadLink(file.public_key)" class="ws-button ws-button-secondary small">View Attachment</a>
                </td>
            </tr>
            </tbody>
        </table>
        <div v-else class="small-note">
            There are no attachments on this {{ itemType }}.
        </div>

        <h4><b>Invoices</b></h4>
        <table v-if="item.invoices?.length" id="oms-job-invoices"  class="worksends-table">
            <thead>
            <tr>
                <th>Attached File</th>
                <th>Payment Status</th>
                <th>Date Added</th>
                <th style="width: 160px">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="file in item.invoices" v-bind:key="file.id">
                <td class="field-file-name">
                    <a target="_blank" :href="downloadLink(file.public_key)">
                        <div class="oms-file-icon"><div class="text">{{ file.file_info.extension }}</div></div>
                        <div>{{ file.name }}</div>
                    </a>
                </td>
                <td>
                    <div :class="'invoice-status status-'+file.status">{{ file.status==='part'? 'Partly Paid' : file.status }}</div>
                </td>
                <td>
                    {{ file.created_at | moment("DD/MM/YY h:mma") }}
                </td>
                <td>
                    <a target="_blank" :href="downloadLink(file.public_key)" class="ws-button ws-button-secondary small">View Attachment</a>
                </td>
            </tr>
            </tbody>
        </table>
        <div v-else class="small-note">
            There are no invoices attached to this {{ itemType }}.
        </div>
        <enquiry-modal v-if="modals.omsEnquiryModal" :job="item"></enquiry-modal>
    </div>
</template>

<script>
import DoughnutChart from "@/components/charts/DoughnutChart.vue";
import EnquiryModal from "@/pages/orders/EnquiryModal.vue";

export default {
    name: "OMSJobDetail",
    components: {EnquiryModal, DoughnutChart},
    methods: {
        async fetchData() {
            return this.dispatchWaitAndNotify('getOMSJob', {job_id: this.$route.params.id}, false, true)
                .finally(() => {
                    //
                });
        },
        donughtChartData(data) {
            console.log(data);
            return {
                labels: ['Complete','Remaining'],
                datasets: [{
                    backgroundColor: ['#5DAEB7','#dddddd'],
                    data: [
                        data.finished,
                        data.total-data.finished
                    ]
                }]
            };
        },
        statusName(name) {
            return this.jobStatuses[name] ?? name;
        },
        enquiryStatusName(name) {
            return this.enquiryStatuses[name] ?? name;
        },
        enquirySourceName(name) {
            return this.enquirySources[name] ?? name;
        },
        downloadLink(key) {
            return process.env.VUE_APP_OMS_BASE_URL+'/worksends-documents/attachments/'+key;
        },
    },
    async mounted() {
        await this.fetchData();
    },
    computed: {
        item() {
            return this.$store.state.oms.jobDetail;
        },
        modals() {
            return this.$store.state.modals;
        },
        jobStatuses() {
            return this.$store.state.oms.jobStatuses;
        },
        enquiryStatuses() {
            return this.$store.state.oms.enquiryStatuses;
        },
        enquirySources() {
            return this.$store.state.oms.enquirySources;
        },
        lastCustomerPackQuote() {
            return this.item.customer_packs[0] ? this.item.customer_packs[0].quote : null;
        },
        currencySymbol() {
            switch (this.lastCustomerPackQuote?.currency) {
                case "GBP": return '£';
                case "EUR": return '€';
                default: return '$';
            }
        },
        itemType() {
            return this.item.state;
        }
    }
}
</script>

<style scoped>

h3 span {
    text-transform: capitalize;
}

#job-overview {
    display: flex;
    width: 100%;
    max-width: 1240px;
    
    #job-overview-left {
        flex: 2;
    }

    #job-overview-right {
        flex: 1;
    }
}

#job-info, #enquiry-info {
    min-width: 0;
    width: auto;
    
    tr {
        td {
            padding: 20px 30px !important;
            
            label {
                font-size: 12px;
                opacity: 0.75;
                margin: 0;
                display: block;
            }
            
            .value {
                font-size: 16px;
                
                & > span {
                    opacity: 0.5;
                }
            }
        }
    }
}

#job-quote {
    margin-left: 10px;
    background: #48576F !important;
    color: white !important;
    
    tr {
        td {
            padding: 4px 30px !important;
            border: none;
            font-size: 14px;
            
            h5 {
                font-size: 18px;
                font-style: italic;
            }
        }
        
        &:first-child {
            td {
                padding: 20px 30px 15px !important;
            }
        }

        &:last-child {
            td {
                padding: 10px 30px 20px !important;
            }
        }
    }
}


.status, .customer-pack-status, .invoice-status {
    text-transform: uppercase;
    padding: 5px 12px;
    background: #E1E1E1;
    letter-spacing: 0.05em;
    display: inline-block;
    border-radius: 4px;
    font-size: 12px;
}

.status-hold,
.status-rejected,
.status-unpaid,
.status-enquiry_payment {
    background: #FACECE;
}


.status-draft,
.status-enquiry_fresh,
.status-awaiting_production {
    background: #E1E1E1;
}

.status-ordered,
.status-unconfirmed,
.status-part,
.status-enquiry_progress {
    background: #FAEDCE;
}

.status-qc,
.status-enquiry_invoice {
    background: #ECCCF1;
}

.status-production_done,
.status-packaging,
.status-approved,
.status-paid,
.status-enquiry_ready {
    background: #B3D6F5;
}

.status-sent {
    background: #DEECEE;
}

.status-completed {
    background: #C7DDE0;
}


.estimate {
    font-style: italic;
    color: #E89D6B;
}


.production-progress {
    display: flex;

    b {
        line-height: 30px;
        margin-left: 6px;
        font-size: 16px;
    }
}

.oms-file-icon {
    background: rgb(26, 131, 179);
    border-radius: 5px 0 3px 3px;
    position: absolute;
    left: 0;
    top: 4px;
    height: 28px;
    width: 20px;

    &::before,
    &::after {
        position: absolute;
        top: 0;
        right: 0;
        content: '';
    }
    &::before {
        border-bottom: 8px solid #78AAF6;
        border-right: 8px solid transparent;
        border-bottom-left-radius: 3px;
        outline: 2px solid white;
    }
    &::after {
        border-bottom: 8px solid transparent;
        border-right: 8px solid white;
    }

    .text {
        color: white;
        line-height: 35px;
        font-size: 10px;
        font-weight: bold;
        text-align: center;
    }
}

#oms-job-customer-packs .field-version a, .field-file-name a {
        position: relative;
        display: inline-block;
        padding-left: 30px;
        font-size: 13px;
        line-height: 34px;
        margin-left: 5px;
}

.enquiry-details {
    margin-top: 15px;
    white-space: pre-wrap;
}


</style>